import React from 'react';
import { Card, Typography, IconButton, Box, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { NotificationState } from '../types';
import { useNotifications } from '../store/hooks';

export const NotificationCards: React.FC = () => {
  const { notifications, markOpened, remove } = useNotifications();

  const unreadNotifications = notifications.filter((n: NotificationState) => n.isOpened === 0);

  const handleOpen = async (n: NotificationState) => {
    markOpened(n.notification_id!);
    if (n.external_url) {
      window.location.href = n.external_url;
    } else if (n.internal_url) {
      window.location.href = n.internal_url;
    }
  };

  const handleRemove = async (n: NotificationState) => {
    remove(n.notification_id!);
  };

  if (unreadNotifications.length === 0) return null;

  return (
    <Box sx={{ flexGrow: 1, overflow: 'auto', position: 'relative', pt: 2, px: 2, pb: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'text.disabled',
            fontSize: '0.75rem',
            fontWeight: 500,
          }}
        >
          Notifications
        </Typography>
      </Box>
      <Divider sx={{ marginY: 2, width: '100%' }} />
      {unreadNotifications.map((n: NotificationState) => (
        <Card
          key={n.notification_id}
          onClick={() => handleOpen(n)}
          sx={{
            mb: 2,
            cursor: 'pointer',
            p: 2,
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            borderRadius: 2,
          }}
          elevation={0}
          variant="outlined"
        >
          <Box sx={{ alignSelf: 'center' }}>
            <Typography variant="subtitle2">{n.title}</Typography>
            {n.text && (
              <Typography variant="body2" color="text.secondary">
                {n.text}
              </Typography>
            )}
          </Box>
          <IconButton
            size="medium"
            onClick={e => {
              e.stopPropagation();
              handleRemove(n);
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Card>
      ))}
    </Box>
  );
};
